import { render, staticRenderFns } from "./ShipmentEdit.vue?vue&type=template&id=2d0207a6&scoped=true"
import script from "./ShipmentEdit.vue?vue&type=script&lang=js"
export * from "./ShipmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0207a6",
  null
  
)

export default component.exports